import React, { useState } from 'react';
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import { LOGIN_URL } from '../components/constants';

const Login = () => {
    const [msisdn, setMsisdn] = useState('');
    const [pin, setPin] = useState('');
    const [redirect, setRedirect] = useState(false);
    const [showFail, setShowFail] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const[responseDesc, setResponseDesc] = useState("");
    const [errorMessage, setErrorMessage] = useState(false); 

    axios.defaults.withCredentials = true;

    const submit = async (e: React.SyntheticEvent) => {
        e.preventDefault();

        try {
            const { data } = await axios.post(
                `${LOGIN_URL}`,
                {
                    msisdn,
                    pin,
                } 
            );
            
            if (data.response_code === "60041"){
                //ToDo shoe error message
                setShowFail(true);
                setErrorMessage(data.message);
            }else{
                setShowSuccess(true);
                setResponseDesc(data.message); 
                setRedirect(true);
            }
            //
        } catch (error) {
            console.error('Login failed:', error);
        }
    };

    // const passableParams = {
    //     msisdn,
    // };

    if (redirect) {
        return <Navigate to={'/'}  />;
    }

    return (
        <div className="flex items-center justify-center h-screen">
            <div className="bg-white p-6 rounded-lg shadow-md">
                <h2 className="text-2xl font-bold mb-4">Login</h2>
                <form className="flex flex-col gap-4" onSubmit={submit}>
                    <input
                        type="tel"
                        placeholder="Phone"
                        className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none"
                        onChange={(e) => setMsisdn(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="PIN"
                        className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none"
                        onChange={(e) => setPin(e.target.value)}
                        required
                    />
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-md shadow-md transition duration-300"
                    >
                        Login
                    </button>
                </form>
                <div className='font-bold mt-4 text-center'>
                    <p className="text-center"> OR </p>
                Send the word <span className="text-blue-500 text-3xl">RACE </span> to <span className="text-blue-500 text-3xl">23887</span> to REGISTER
                </div>
               
            </div>
            {showSuccess && (
        <div className="bg-green-500 text-white p-4 absolute top-0 right-0 mt-10 mr-10 rounded">
          {responseDesc}
        </div>
        )}
         {showFail && (
       <div className="bg-red-500 text-white p-4 absolute top-0 left-1/2 transform -translate-x-1/2 mt-10 rounded">
       {errorMessage}
     </div>
      )}

        </div>
    );
};

export default Login;